<template>
    <div class="app-body">
        <div class="a-flex-rsbc">
            <bread-crumb></bread-crumb>
        </div>
        <el-card class="el-main">
            <div slot="header" class="clearfix a-flex-rfsc a-fw-700">
                <span class="a-fs-18">No. {{ deviceCode || '-' }}</span>
                <el-tag type="success" v-if="deviceInfo.exportStatus == 2">已导出</el-tag>
                <el-tag type="warning" v-if="deviceInfo.exportStatus == 0">未导出</el-tag>
                <el-tag type="danger" v-if="deviceInfo.exportStatus == 1">更新未导出</el-tag>
            </div>
            <div class="a-flex-rfsfs a-flex-wrap">
                <div class="list-item">
                    <span class="list-item-title">设备种类</span>
                    <span class="list-item-value">{{ deviceInfo.deviceCategoryName || '-' }}</span>
                </div>
                <div class="list-item">
                    <span class="list-item-title">设备类型</span>
                    <span class="list-item-value">{{ deviceInfo.deviceTypeName }}</span>
                </div>
                <div class="list-item">
                    <span class="list-item-title">所属站点</span>
                    <span class="list-item-value">{{ deviceInfo.stationName || '-' }}</span>
                </div>
                <div class="list-item">
                    <span class="list-item-title">所属加盟商</span>
                    <span class="list-item-value">{{ deviceInfo.companyName || '-' }}</span>
                </div>
                <div class="list-item">
                    <span class="list-item-title">最近上传时间</span>
                    <span class="list-item-value">{{ deviceInfo.lastUploadTime || '-' }}</span>
                </div>
                <div class="list-item">
                    <span class="list-item-title">最近导出时间</span>
                    <span class="list-item-value">{{ deviceInfo.lastExportTime || '-' }}</span>
                </div>
            </div>
            <div class="a-fw-700 a-fs-14 a-c-333 a-fs-18 a-mt-16" style="padding-bottom: 24px">历史上传</div>
            <el-timeline>
                <el-timeline-item
                    color="#B9B9B9"
                    v-for="(item, index) in tableData"
                    :key="index"
                    :timestamp="item.createTime">
                    <el-button icon="el-icon-upload2" type='primary' @click="exportfile(item)">导出</el-button>
                    <div class="a-flex-cfsfs ">
                        <div class="a-fs-12 a-flex-cfsfs a-mt-10">
                            <span class="a-fs-16 a-fw-700">碰一下</span>
                            <div class="a-flex-rfsfs a-flex-wrap">
                                <el-image 
                                    v-for="(ite,idx) in item.touchPic"
                                    :key="idx"
                                    style="width: 80px; height: 80px; border-radius: 8px; margin: 10px 10px 0 0"
                                    :src="ite" 
                                    :preview-src-list="item.touchPic">
                                </el-image>
                            </div>
                        </div>
                        <div class="a-fs-12 a-flex-cfsfs a-mt-20" >
                            <span class="a-fs-16 a-fw-700">设备刷蓝</span>
                            <div class="a-flex-rfsfs a-flex-wrap">
                                <el-image 
                                    v-for="(ite,idx) in item.devicePic"
                                    :key="idx"
                                    style="width: 80px; height: 80px; border-radius: 8px; margin: 10px 10px 0 0"
                                    :src="ite" 
                                    :preview-src-list="item.devicePic">
                                </el-image>
                            </div>
                        </div>
                    </div>
                </el-timeline-item>
            </el-timeline>
            <div style="width: 100%;height:100%" class="a-flex-rcc" v-if="!tableData.length">
                <el-empty :image-size='100' description="暂无记录"></el-empty>
            </div>
        </el-card>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    components: {
    },
    data () {
        return {
            id: '',
            deviceCode: '',
            deviceInfo: {},
            tableData: [],
            exportStatusDic: []
        }
    },
    mounted () {
        this.$getDic('antChainExportStatus').then(res=>{ this.exportStatusDic = res; })
        this.id = this.$route.query.id
        this.deviceCode = this.$route.query.deviceCode
        if(this.id) {
            this.getDetail()
            this.getDetailList()
        }
    },
    methods:{
        // 查询详情
        getDetail () {
            this.$Axios._get({
                url: this.$Config.apiUrl.antChainDeviceUploadDetail,
                params: {
                    id: this.id
                }
            }).then(res => {
                this.deviceInfo = Object.assign({},res.result.data)
            })
        },
        getDetailList () {
            this.$Axios._get({
                url: this.$Config.apiUrl.antChainDeviceUploadRecord,
                params: {
                    id: this.id
                }
            }).then(({data}) => {
                this.tableData = data.map(item=>{
                    return {
                        ...item,
                        devicePic: JSON.parse(item.devicePic),
                        touchPic: JSON.parse(item.touchPic),
                    }
                })
            })
        },
        exportfile (datas) {
            this.$exfile({
                code: 30,
                fileName: '设备图片拍摄-' + (this.deviceCode + '（上传时间：' + datas.createTime + '）'),
                params: {
                    recordId: datas.id
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.list-item{
    padding: 10px 0;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    .list-item-title{
        width: 100px;
        text-align: left;
        color: #666666;
        display: inline-block;
    }
    .list-item-value{
        width: 240px;
        text-align: left;
        color: #333333;
        font-weight: 700;
        display: inline-block;
    }
}
.workOrder-content-item{
    background: #F2F6FC;
    padding: 2px 8px;
    border-radius: 4px;
    margin-right: 12px;
}
.send-user{
    background: #53A8FF;
    color: #ffffff;
    border-radius: 4px;
    padding: 0 10px;
    margin: 0 10px 10px 0;
}
.mt64{
    margin-top: 64px
}
.mt21{
    margin-top: 12px
}
.mr80{
    margin-right: 80px;
}
.c79{
    color: #797979
}
.title{
    width: 150px;
    margin-right: 16px;
}
.content{
    width: 240px
}
.tips{
    font-size: 12px;
    color: #909399;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    line-height: 22px;
}
</style>